import { h, Component } from 'preact'
import axios from 'axios'
import { User } from './User'
import Selector from '../selector/Selector'
import UserAvatar from '../User/UserAvatar'

interface Props {
  url: string
  onChange: (u: User[]) => void
  placeholder?: string
  permission?: string
  initialItems?: User[]
  excludeUsers?: number[]
  error: boolean
}

class UserSelector extends Component<Props> {
  async validateUser (userName: string): Promise<User[]> {
    const response = await axios.get(this.props.url, {
      params: {
        query: userName,
        excludeUsers: this.props.excludeUsers?.join(',') || ''
      }
    })
    const matchedUser = response.data.length === 1 && response.data[0].name === userName
    return matchedUser
      ? response.data[0]
      : null
  }

  baseUrl () {
    let excluded = ''
    if (this.props.excludeUsers) {
      excluded = this.props.excludeUsers.join(',')
    }
    return `${this.props.url.split('?')[0]}?excludeUsers=${excluded}${this.props.permission ? `&permission=${this.props.permission}` : ''}&query=`
  }

  render (props: Props) {
    return (
      <div class='user-selector'>
        <Selector
          initialItems={props.initialItems}
          placeholder={props.placeholder}
          config={{
            dynamic: {
              baseUrl: this.baseUrl(),
              omitItemsKey: 'id',
              dynamicItemElement: (item: User) => <UserItem user={item} />
            },
            itemElement: (item: User) => <UserItem user={item} />,
            itemToStringKey: 'name',
            delimiter: ',',
            keys: {
              insert: ['Enter', 'Tab', ',', ';'],
              remove: ['Backspace']
            }
          }}
          onValidate={async (value: string) => await this.validateUser(value)}
          onChange={(users: User[]) => props.onChange(users)}
          error={props.error}
        />
      </div>
    )
  }
}

const UserItem = ({ user }: { user: User}) =>
  <div>
    {user.id && <UserAvatar user={user} />}
    <span>{user.name}</span>
  </div>

export default UserSelector
